import { render, staticRenderFns } from "./CartNumber.vue?vue&type=template&id=6303b200&scoped=true"
import script from "./CartNumber.vue?vue&type=script&lang=js"
export * from "./CartNumber.vue?vue&type=script&lang=js"
import style0 from "./CartNumber.vue?vue&type=style&index=0&id=6303b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303b200",
  null
  
)

export default component.exports